/**
 * Animated voice waveform — bars rising and falling on a sine curve.
 * Used in the hero, voice demo, and various feature tiles.
 */
export default function Waveform({ bars = 24, large = false, active = true, color = 'currentColor' }) {
  const heights = Array.from({ length: bars }, (_, i) => {
    const v = Math.abs(Math.sin(i * 1.3 + 0.5)) * 0.7 + 0.3;
    return v;
  });
  return (
    <div className={`lc-waveform${large ? ' lg' : ''}`} style={{ color }}>
      {heights.map((h, i) => (
        <span
          key={i}
          style={{
            height: `${h * 100}%`,
            animationDelay: `${(i * 0.07) % 1.1}s`,
            animationPlayState: active ? 'running' : 'paused',
            opacity: active ? 1 : 0.4,
          }}
        />
      ))}
    </div>
  );
}
